/**
 * Created by Tukta on 15/7/2560.
 */
import React, { Component } from 'react'
import moment from 'moment'
import { TabContent, TabPane, Nav, NavItem, NavLink, ModalBody, Modal, ModalFooter, ModalHeader } from 'reactstrap'
import classnames from 'classnames'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import axios from 'axios'
import pdfMake from 'pdfmake/build/pdfmake'
import DatePicker from 'react-datepicker'
import { APIURL} from '../../../config/config'

// import BigCalendar from 'react-big-calendar'
// import NumberFormat from "react-number-format"
// import DatePicker from 'react-datepicker/es'
// import * as moment from 'moment';
// const localizer = BigCalendar.momentLocalizer(moment)

/*BigCalendar.setLocalizer(
    BigCalendar.globalizeLocalizer(globalize)
);*/

const localizer = momentLocalizer(moment)
require ("react-big-calendar/lib/css/react-big-calendar.css");


export  default class CalendarList extends Component{
    constructor (props){
        super(props);
        this.state = {
            data:[],
            calendarCustomer: [],
            birth:[],
            car: '',
            carTax: [],
            carInsurance: [],
            activeTab: '2',
            user: {},
            user_type: '',
            date_start: new Date(),
            date_end: new Date(),
            activeTab: '1',
            width: 0,
            height: 0,
        }
        this.printTax = this.printTax.bind(this)
        this.printInsurance = this.printInsurance.bind(this)
        this.loadCarTax = this.loadCarTax.bind(this)
        this.loadCarInsurance = this.loadCarInsurance.bind(this)
        this.handleDateStart = this.handleDateStart.bind(this)
        this.handleDateEnd   = this.handleDateEnd.bind(this)
        this.toggle = this.toggle.bind(this)
        this.loadCustomerCalendar = this.loadCustomerCalendar.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    loadData () {
        axios.get(APIURL + '/calendar_car_license/')
            .then(res => {
                this.setState({data: res.data})
            }).catch(error => {
            this.setState({data: []})
        })
    }

    componentDidMount() {
        this.loadData()
        this.loadCustomerCalendar()
        // this.loadCarTax()
        // this.loadCarInsurance()
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    loadCustomerCalendar() {
        axios.post(APIURL + '/calendar_customer', {})
          .then(res => {

              let data = res.data

              let calendarCustomers = []
              for (let i =0 ; i < data.length; i++) {
                  let custData = data[i]
                  let calendarCustomer = {
                      ...custData,
                      title: custData.title_short,
                      desc: custData.title
                  }
                  calendarCustomers.push(calendarCustomer)
              }

              this.setState({calendarCustomer: calendarCustomers})
          }).catch(error => {
            this.setState({calendarCustomer: []})
        })
    }


    loadCarTax () {

        if(this.state.date_start > this.state.date_end){
            alert('วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ')
            return
        }
        let date_start =  moment(this.state.date_start).format('YYYY-MM-DD')
        let date_end   =  moment(this.state.date_end).format('YYYY-MM-DD')
        const data = {
            date_start,
            date_end
        }

        axios.post(APIURL + '/calendar_car_license/tax', data)
          .then(res => {
              console.log('res.status=', res.status)
              console.log('res.data=', res.data.length)
              if( res.data.length > 0) {
                  this.setState({carTax: res.data}, () => this.printTax())
              } else {
                  alert('ไม่พบข้อมูลการต่อภาษี ' + date_start + ' ถึง ' + date_end)
              }
          }).catch(error => {
            this.setState({carTax: []})
        })
    }

    loadCarInsurance () {

        if(this.state.date_start > this.state.date_end){
            alert('วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ')
            return
        }

        let date_start =  moment(this.state.date_start).format('YYYY-MM-DD')
        let date_end   =  moment(this.state.date_end).format('YYYY-MM-DD')
        const data = {
            date_start,
            date_end
        }

        axios.post(APIURL + '/calendar_car_license/insurance', data)
          .then(res => {
              console.log('res.data=', res.data.length)
              if( res.data.length > 0) {
                  this.setState({ carInsurance: res.data }, () => this.printInsurance())
              } else {
                  alert('ไม่พบข้อมูลการต่อประกัยภัยรถ ' + date_start + ' ถึง ' + date_end)
              }
          }).catch(error => {
            this.setState({carInsurance: []})
        })
    }

    eventStyleGetter(event, start, end, isSelected) {
        var backgroundColor = '#' + event.hex_color;
        var style = {
            backgroundColor: backgroundColor,
            borderRadius: '5px',
            opacity: 0.8,
            color: 'white',
            border: '0px',
            display: 'block',
        };
        return {
            style: style
        };
    }

    handleDateStart(date){
        this.setState({
            date_start: date
        })
    }

    handleDateEnd(date){
        this.setState({
            date_end: date
        })
    }

    printTax() {
        var carTaxRows = []
        var row = []
        var lenTax = this.state.carTax.length
        this.state.carTax.forEach((car, index) => {
            var carTitle = {
                text: (index +1) + " : " + car.title,
                style: 'bodyText'
            };

            if (index % 2 === 0) {
                // 0
                row = []
                row.push(carTitle)
                if(lenTax === (index + 1)) {
                    row.push({
                        text: '-',
                        style: 'bodyText'
                    })
                    carTaxRows.push(row)
                }
            } else {
                // 1
                row.push(carTitle)
                carTaxRows.push(row)
            }
        })

        /* const startOfMonth = moment().clone().startOf('month').format('YYYY-MM-DD');
        const endOfMonth   = moment().clone().endOf('month').format('YYYY-MM-DD hh:mm');
        var futureMonth = moment(endOfMonth).add(2, 'M');
        var futureMonthEnd = moment(futureMonth).endOf('month').format('YYYY-MM-DD'); */

        let date_start =  moment(this.state.date_start).format('YYYY-MM-DD')
        let date_end   =  moment(this.state.date_end).format('YYYY-MM-DD')

        var headerText = 'แจ้งเตือนการต่อภาษีรถยนต์ 3 เดือน : ' + date_start + ' ถึง ' + date_end
        var widthTable = ['auto', 'auto']
        var docDefinition = {
            pageOrientation: 'portrait',
            pageSize: 'A4',
            pageMargins: [45, 30, 45, 30], // margin: [left, top, right, bottom]
            content: [
                {text: headerText, style: 'bodyHead', lineHeight: 1.3},
                {
                    table: {
                        widths: widthTable,
                        body: carTaxRows
                    }
                },
            ],
            styles: {
                bodyHead: {
                    fontSize: 16,
                    bold: true,
                    alignment: 'center'
                },
                bodyText: {
                    fontSize: 14,
                },
                bodyBold: {
                    fontSize: 14,
                    bold: true,
                    alignment: 'center'
                },
                textCenter: {
                    fontSize: 14,
                    alignment: 'center'
                },
            },
            defaultStyle: {
                font: 'THSarabunNew'
            }
        };

        pdfMake.createPdf(docDefinition).open()
    }

    printInsurance() {
        var carInsuranceRows = []
        var row = []
        var lenTax = this.state.carInsurance.length
        this.state.carInsurance.forEach((car, index) => {
            var carTitle = {
                text: (index +1) + " : " + car.title,
                style: 'bodyText'
            };

            if (index % 2 === 0) {
                // 0
                row = []
                row.push(carTitle)
                if(lenTax === (index + 1)) {
                    row.push({
                        text: '-',
                        style: 'bodyText'
                    })
                    carInsuranceRows.push(row)
                }
            } else {
                // 1
                row.push(carTitle)
                carInsuranceRows.push(row)
            }
        })

        /*const startOfMonth = moment().clone().startOf('month').format('YYYY-MM-DD');
        const endOfMonth   = moment().clone().endOf('month').format('YYYY-MM-DD hh:mm');
        var futureMonth = moment(endOfMonth).add(2, 'M');
        var futureMonthEnd = moment(futureMonth).endOf('month').format('YYYY-MM-DD');*/

        let date_start =  moment(this.state.date_start).format('YYYY-MM-DD')
        let date_end   =  moment(this.state.date_end).format('YYYY-MM-DD')

        var headerText = 'แจ้งเตือนการต่อประกันภัยรถยนต์ จาก ' + date_start + ' ถึง ' + date_end
        var widthTable = ['auto', 'auto']
        var docDefinition = {
            pageOrientation: 'portrait',
            pageSize: 'A4',
            pageMargins: [45, 30, 45, 30], // margin: [left, top, right, bottom]
            content: [
                {text: headerText, style: 'bodyHead', lineHeight: 1.3},
                {
                    table: {
                        widths: widthTable,
                        body: carInsuranceRows
                    }
                },
            ],
            styles: {
                bodyHead: {
                    fontSize: 16,
                    bold: true,
                    alignment: 'center'
                },
                bodyText: {
                    fontSize: 14,
                },
                bodyBold: {
                    fontSize: 14,
                    bold: true,
                    alignment: 'center'
                },
                textCenter: {
                    fontSize: 14,
                    alignment: 'center'
                },
            },
            defaultStyle: {
                font: 'THSarabunNew'
            }
        };

        pdfMake.createPdf(docDefinition).open()
    }

    render(){

        let user = this.state.user.user

        let width = this.state.width

        return (
            <>
             <Nav tabs>
                      <NavItem>
                          <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                          >
                              <i className="icon-calendar"/> ปฏิทินรถ ภาษี & ประกัน
                          </NavLink>
                      </NavItem>
                      <NavItem>
                          <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}
                          >
                              <i className="icon-calendar"/> ปฏิทินลูกหนี้
                          </NavLink>
                      </NavItem>
             </Nav>
               <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <div className="card">
                        <div className="card-block">
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    <div className="card card-accent-info">
                                        <div className="card-header">

                                            <div className="row">
                                            <div className="col-2">
                                                <strong> ปฏิทินเตือนความจำ </strong>
                                            </div>


                                                <div className="col-6 mt-1 text-right">
                                                    <div className="row text-right">
                                                        <div className="col-md-2 text-right">
                                                            พิมพ์จาก
                                                        </div>
                                                        <div className="col-10 text-right">
                                                            <div className="row text-right ">
                                                                <div className="col-5 text-right">
                                                                    <DatePicker
                                                                    selected={this.state.date_start}
                                                                    onChange={this.handleDateStart}
                                                                    dateFormat="yyyy-MM-dd"
                                                                    type="text"
                                                                    className="form-inline"
                                                                    placeholder=""
                                                                    />
                                                                </div>

                                                                <div className="col-1 text-center">

                                                                </div>

                                                                <div className="col-5 text-right">
                                                                    <DatePicker
                                                                    selected={this.state.date_end}
                                                                    onChange={this.handleDateEnd}
                                                                    dateFormat="yyyy-MM-dd"
                                                                    type="text"
                                                                    className="form-inline"
                                                                    placeholder=""
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            <div className="col-4 mt-1">
                                                <button className="btn btn-success float-right"
                                                        onClick={() => this.loadCarTax()}
                                                >
                                                    <i className="icon-printer"></i>&nbsp; พิมพ์ต่อภาษี
                                                </button>

                                                <button
                                                className="btn btn-primary float-right mr-1"
                                                onClick={() => this.loadCarInsurance()}
                                                >
                                                    <i className="icon-printer"></i>&nbsp; พิมพ์ประกันภัยรถ
                                                </button>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="card-block">
                                            <Calendar
                                                localizer={localizer}
                                                selectable
                                                style={{height: '960px' , backgroundColor:'#ffffff'}}
                                                events={this.state.data}
                                                defaultView='month'
                                                defaultDate={new Date()}
                                                onSelectEvent={event => alert(event.title)}
                                                eventPropGetter={(this.eventStyleGetter)}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                  <div className="row">
                              <div className="col-lg-12">
                                  <div className="card">
                                      <div className="card-block">
                                          <div className="row">
                                              <div className="col-sm-12 col-md-12">
                                                  <div className="card card-accent-success">
                                                      <div className="card-header card-customer">
                                                          <div className="row">
                                                              <div className="col-12">
                                                                  <strong className="text-title"> ปฏิทินลูกหนี้ </strong>
                                                              </div>
                                                          </div>

                                                          <div className="row">
                                                              <div className="col-7 mt-4">
                                                                  {/* <div className="row">
                                                                      <div className="ml-5 mt-1 text-title">
                                                                          จาก
                                                                      </div>
                                                                      <div className="col-10 text-right">
                                                                          <div className="row ">
                                                                              <div className="col-5">
                                                                                  <DatePicker
                                                                                      selected={this.state.date_start}
                                                                                      onChange={this.handleDateStart}
                                                                                      dateFormat="yyyy-MM-dd"
                                                                                      type="text"
                                                                                      className="form-control"
                                                                                      placeholder=""
                                                                                      style={{zIndex: 99999}}
                                                                                      popperProps={{
                                                                                          positionFixed: true
                                                                                      }}
                                                                                  />
                                                                              </div>

                                                                              <div className="col-5 text-right">
                                                                                  <DatePicker
                                                                                      selected={this.state.date_end}
                                                                                      onChange={this.handleDateEnd}
                                                                                      dateFormat="yyyy-MM-dd"
                                                                                      type="text"
                                                                                      className="form-control"
                                                                                      placeholder=""
                                                                                  />
                                                                              </div>
                                                                          </div>
                                                                      </div>
                                                                  </div> */}
                                                              </div>

                                                              <div className="col-5 mt-4">
                                                                  {/* {
                                                                      checkGroupPermission(152, this.state.grouppermissions).printed ? (
                                                                  <button className="btn btn-success float-right mt-1 ml-3"
                                                                          onClick={() => this.loadCustomerDebtor()}
                                                                  >
                                                                      <i className="icon-printer"/>&nbsp; พิมพ์นัดหมาย
                                                                  </button>
                                                                          ) :
                                                                          null
                                                                  }

                                                                  {
                                                                      checkGroupPermission(152, this.state.grouppermissions).modified ? (
                                                                  <Link to="/calendar/manage" >
                                                                      <button className="btn btn-danger float-right mt-1">
                                                                          จัดการปฏิทินนัดหมาย
                                                                      </button>
                                                                  </Link>
                                                                          ) :
                                                                          null
                                                                  }

                                                                  {
                                                                      checkGroupPermission(152, this.state.grouppermissions).created ? (
                                                                  <Button className="btn btn-info float-right mt-1 mr-3" onClick={this.toggleAppointment}>
                                                                      เพิ่มนัดหมายลูกค้า
                                                                  </Button>
                                                                          ) :
                                                                          null
                                                                  } */}
                                                              </div>
                                                          </div>
                                                      </div>

                                                      {/* <Modal isOpen={this.state.toggle_appointment_add}
                                                             toggle={this.toggleAppointment}
                                                             className={'modal-lg'}
                                                             style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}
                                                      >
                                                          <ModalBody>
                                                              <AppointmentForm
                                                                 onToggle={this.toggleAppointment}
                                                                 user = {user}
                                                                 onReload={this.onReload}
                                                              />
                                                          </ModalBody>
                                                      </Modal> */}


                                                      <div className="card-block">
                                                        
                                                          <Calendar
                                                              localizer={localizer}
                                                              selectable
                                                              style={{height: '960px' , backgroundColor:'#ffffff'}}
                                                              events={this.state.calendarCustomer}
                                                              defaultView='month'
                                                              views={['month']}
                                                              defaultDate={new Date()}
                                                              onSelectEvent={event => alert(event.desc)}
                                                              eventPropGetter={(this.eventStyleGetter)}
                                                              popup
                                                          />

                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                  </TabPane>
                </TabContent>
            </>
        );
    }
}
